export const GetParameter = (parameterName) => {
  var result = null,
    tmp = [];
  if (typeof window !== 'undefined') {
    window.location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === parameterName) result = decodeURI(tmp[1]);
      });
  }
  return result;
};
